import { mapValues } from 'lodash';
/**
 * Version 19 migrations guest widget
 * - Adding default styles to display guests
 */

export default function v19(website) {
  return {
    ...website,
    eventVersion: 19,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'GuestRegistration' && !layoutItem.config.style.productTableStyles) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            guestRegButtonText: 'EventWidgets_GuestRegistration_DefaultButtonText_resx',
            style: {
              ...layoutItem.config.style,
              guestRegButtonStyles: {
                styleMapping: 'primaryButton',
                customSettings: {
                  text: {
                    textAlign: 'left'
                  }
                }
              },
              attendeeNameStyles: {
                styleMapping: 'header3',
                customSettings: {
                  text: {
                    textAlign: 'left'
                  }
                }
              },
              fieldStyles: {
                styleMapping: 'body1',
                customSettings: {
                  border: {
                    thickness: 0
                  },
                  spacing: {
                    padding: {
                      paddingBottom: 15,
                      paddingTop: 0,
                      paddingLeft: 0,
                      paddingRight: 0
                    }
                  }
                }
              },
              productTableStyles: {
                productHeaderStyles: {
                  styleMapping: 'body1',
                  customSettings: {
                    background: {
                      color: 'primary'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 9,
                        paddingTop: 9,
                        paddingLeft: 10,
                        paddingRight: 0
                      }
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
